import { render } from "./NutritionalPropertiesList.vue?vue&type=template&id=11a24398&scoped=true"
import script from "./NutritionalPropertiesList.vue?vue&type=script&lang=js"
export * from "./NutritionalPropertiesList.vue?vue&type=script&lang=js"

import "./NutritionalPropertiesList.vue?vue&type=style&index=0&id=11a24398&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a24398"],['__file',"resources/js/modules/product-categorization/components/filter/NutritionalPropertiesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11a24398"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11a24398', __exports__)) {
    api.reload('11a24398', __exports__)
  }
  
  module.hot.accept("./NutritionalPropertiesList.vue?vue&type=template&id=11a24398&scoped=true", () => {
    api.rerender('11a24398', render)
  })

}


export default __exports__